import { GraphQLResult } from "@aws-amplify/api";
import { API } from "aws-amplify";
import { Dispatch, DispatchWithoutAction, SetStateAction } from "react";
import { toast } from 'react-toastify';

import { deletePest } from "../../../graphql/mutations";
import { updateLoading } from "../../../redux/slice/appSlice";
import { AppDispatch } from "../../../redux/store";
import { DeletePestMutation, Pest } from "../../../types/api";

interface deletePestByIdProps {
  id: string | undefined;
  index: number;
  dispatch: AppDispatch;
  updatePests: Dispatch<SetStateAction<(Pest | null)[]>>;
  forceUpdate: DispatchWithoutAction;
}
export const deletePestById: ({
  id,
  index,
  dispatch,
  updatePests,
  forceUpdate
}: deletePestByIdProps) => Promise<void> = async ({
  id,
  index,
  dispatch,
  updatePests,
  forceUpdate
}: deletePestByIdProps) => {
  try {
    dispatch(updateLoading(true));
    const deleteResponse: GraphQLResult<DeletePestMutation> =
      await API.graphql({
        query: deletePest,
        variables: { input: { id } }
      }) as GraphQLResult<DeletePestMutation>;
    if (deleteResponse.data?.deletePest) {
      updatePests((prevState) => {
        if (prevState) {
          prevState.splice(index, 1);
        }
        return prevState;
      });
      forceUpdate();
    }
  } catch (err) {
    // console.log(err)
    toast.dark("Error: Delete Pest.");
  } finally {
    dispatch(updateLoading(false));
  }
};
